import React from 'react';
import { APP_THEMES } from '@shared/config/constants/app';

export const defaultTheme = { theme: APP_THEMES.BLACK };

export const ThemeContext = React.createContext(defaultTheme);
